export function generateId(maxLen = 9, prefix = '') {
  //https://gist.github.com/gordonbrander/2230317
  if (maxLen <= 0) { maxLen = 1; }
  return prefix + Math.random().toString(36).substr(2, maxLen);
}
